module.exports = __webpack_public_path__ + "img/img-404@2x.dc449d28.png";